import { gql } from '@apollo/client';

// List query: intentionally lightweight. It does NOT fetch the heavy `data` blob —
// only the small fields the table renders. `description` is a server-derived label so
// the Description column works without the full payload. The full record (with `data`)
// is fetched per-row on the detail page via AUDIT_TRAIL_DETAIL.
export const ALL_AUDIT_TRAILS = gql`
  query getAuditTrails($input: AudiTrailsInput) {
    auditTrails: getAuditTrails(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          timestamp
          object
          objectId
          action
          entityLabel
          # data is needed so the Description column can fall back to the legacy label
          # (data.formName) for records written before the entityLabel column existed.
          data
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

// Detail query: fetches a single audit record including the full `data` blob for the
// styled diff page. Reuses getAuditTrails filtered by id.
export const AUDIT_TRAIL_DETAIL = gql`
  query getAuditTrailDetail($input: AudiTrailsInput) {
    auditTrails: getAuditTrails(input: $input) {
      edges {
        node {
          id
          timestamp
          object
          objectId
          action
          entityLabel
          data
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;
